import axios from 'axios';
import { getApiBaseUrl } from '../../config/apiBase.js';

const API_BASE_URL = getApiBaseUrl();

// Get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Create axios instance with default headers
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Get top queries data
export const getTopQueries = async (limit = 10, timeRange = '30', tenant = 'all') => {
  try {
    const response = await apiClient.get(`/api/ai/analytics/top-queries?limit=${limit}&timeRange=${timeRange}&tenant=${tenant}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching top queries:', error);
    throw error;
  }
};

// Get zero hit trends data
export const getZeroHitTrends = async (days = 30, tenant = 'all') => {
  try {
    const response = await apiClient.get(`/api/ai/analytics/zero-hit-trends?days=${days}&tenant=${tenant}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching zero hit trends:', error);
    throw error;
  }
};

// Get bug reports by category
export const getBugReportsByCategory = async () => {
  try {
    const response = await apiClient.get('/api/bug/analytics/by-category');
    return response.data;
  } catch (error) {
    console.error('Error fetching bug reports by category:', error);
    throw error;
  }
};

// Get bug reports by status
export const getBugReportsByStatus = async (timeRange = '30', tenant = 'all') => {
  try {
    const response = await apiClient.get(`/api/bug/analytics/by-status?timeRange=${timeRange}&tenant=${tenant}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching bug reports by status:', error);
    throw error;
  }
};

// Get dashboard stats
export const getDashboardStats = async (timeRange = '30', tenant = 'all') => {
  try {
    const response = await apiClient.get(`/api/ai/analytics/dashboard-stats?timeRange=${timeRange}&tenant=${tenant}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    throw error;
  }
};

// Get analytics queries data for tables
export const getAnalyticsQueries = async (limit = 10, timeRange = '30', tenant = 'all') => {
  try {
    const response = await apiClient.get(`/api/ai/analytics/queries?limit=${limit}&timeRange=${timeRange}&tenant=${tenant}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching analytics queries:', error);
    throw error;
  }
};

// Get zero hits data for tables
export const getAnalyticsZeroHits = async (limit = 10, timeRange = '30', tenant = 'all') => {
  try {
    const response = await apiClient.get(`/api/ai/analytics/zero-hits?limit=${limit}&timeRange=${timeRange}&tenant=${tenant}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching analytics zero hits:', error);
    throw error;
  }
};

// Get flagged bugs data for tables
export const getAnalyticsFlaggedBugs = async (limit = 10, timeRange = '30', tenant = 'all') => {
  try {
    const response = await apiClient.get(`/api/bug/analytics/flagged?limit=${limit}&timeRange=${timeRange}&tenant=${tenant}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching analytics flagged bugs:', error);
    throw error;
  }
};

